import { render, staticRenderFns } from "./ManageAccessUserProfile.vue?vue&type=template&id=8604c210&lang=pug"
import script from "./ManageAccessUserProfile.vue?vue&type=script&lang=js"
export * from "./ManageAccessUserProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports